module.exports = __webpack_public_path__ + "img/icon-suoding.671b7c73.svg";